import { FormattedMessage } from 'react-intl';
import {
  Button,
  useAdvertReviewCheckVisibleControl,
  ButtonContentWithLoader,
  ButtonVariant,
} from '@edikk-edikk/ui';
import { FC } from 'react';
import {
  useHandlerClick,
  useReviewCheckToggleContext,
} from '#baseMenu/components/controls/middle-button/review-check-toggle';

const ReviewCheckToggleButton: FC = () => {
  const { isOpen } = useAdvertReviewCheckVisibleControl();
  const { isLoadInProcess } = useReviewCheckToggleContext();
  const handlerClick= useHandlerClick();

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      pill
      textUppercase
      onClick={handlerClick}
      additionalClassName="flex-grow-1"
    >
      <ButtonContentWithLoader isLoading={isLoadInProcess} content={<FormattedMessage defaultMessage="Reviews" />} />
    </Button>
  );
};

export { ReviewCheckToggleButton };
